import styled from 'styled-components';

export const Base = styled.div`
	display: flex;
	flex-direction: column;
	margin-left: 4px;
	margin-right: 2px;
`;

export const Header = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
`;

export const Label = styled.div`
	margin-top: 14px;
	margin-bottom: 12px;
	user-select: none;

	font-size: 14px;
	font-family: 'Inter', sans-serif;
	font-weight: 600;
	color: ${({ theme }) => theme.gray[1000]};

	// truncate text if it's too long
	width: 100%;
	min-width: 0;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
`;

export const DividerWrapper = styled.div`
	margin-left: -20px;
	margin-right: -20px;
`;

export const Children = styled.div`
	display: flex;
	flex-direction: column;
`;

export const Actions = styled.div`
	margin-top: 6px;
	display: flex;
	gap: 4px;
	margin-right: -4px;
`;

export const Action = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;

	background: transparent;
	border: none;
	border-radius: 6px;
	display: flex;
	align-items: center;
	justify-content: center;
	width: 24px;
	height: 24px;

	&:hover {
		background: ${({ theme }) => theme.gray[100]};
	}
`;
